const GMC_TOKEN_KEY = "gmc_token";
const GMC_AUTH_TOKEN_KEY = "gmc_auth_token";

export const getGmcToken = () => {
  return window.localStorage.getItem(GMC_TOKEN_KEY);
};

export const getGmcAuthToken = () => {
  return window.localStorage.getItem(GMC_AUTH_TOKEN_KEY);
};

export const saveGmcToken = token => {
  window.localStorage.setItem(GMC_TOKEN_KEY, token);
};

export const saveGmcAuthToken = token => {
  window.localStorage.setItem(GMC_AUTH_TOKEN_KEY, token);
};

export const destroyGmcToken = () => {
  window.localStorage.removeItem(GMC_TOKEN_KEY);
};

export const destroyGmcAuthToken = () => {
  window.localStorage.removeItem(GMC_AUTH_TOKEN_KEY);
};

export default { 
  getGmcToken, saveGmcToken, destroyGmcToken, 
  getGmcAuthToken, saveGmcAuthToken, destroyGmcAuthToken,
};
